import { CheckCircle2, AlertCircle, XCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { IntegrationConnectionStatus } from '@/types/integrations-redesign';

export interface ConnectionStatusBadgeProps {
  status: IntegrationConnectionStatus;
  compact?: boolean;
}

export function ConnectionStatusBadge({ status, compact }: ConnectionStatusBadgeProps) {
  if (status === 'connected') {
    return (
      <Badge
        variant="outline"
        className="border-green-500 text-green-700 bg-green-50 gap-1 w-fit"
      >
        <CheckCircle2 className="h-3 w-3" />
        {!compact && 'Connected'}
      </Badge>
    );
  }
  if (status === 'error') {
    return (
      <Badge variant="destructive" className="gap-1 w-fit">
        <AlertCircle className="h-3 w-3" />
        {!compact && 'Error'}
      </Badge>
    );
  }
  if (status === 'not_connected') {
    return (
      <Badge variant="secondary" className="gap-1 w-fit">
        <XCircle className="h-3 w-3" />
        {!compact && 'Not Connected'}
      </Badge>
    );
  }
  // not_configured
  return (
    <Badge variant="outline" className="text-muted-foreground gap-1 w-fit">
      {!compact && 'Not Configured'}
    </Badge>
  );
}
